<template>
<v-container>
  <v-row>
    <v-col cols="12" class="text-center">
      <UserListFilterCard/>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="2">
      <v-chip large color="primary">
        تعداد کل: {{ count }}
      </v-chip>
    </v-col>
    <v-col cols="12">
      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="users"
          :items-per-page="25"
          class="elevation-4 row-pointer mb-4"
          :loading="loading"
          loading-text="لطفا صبر کنید"
          no-data-text="داده ای یافت نشد."
          :hide-default-footer="true"
          item-key="user.id"
          single-select
          value="user.id"
      >
        <template v-slot:item.grade="{item}">
          <v-row>{{ getGradeName(item.grade) }}</v-row>
        </template>

        <template v-slot:item.user_movie_graphic_festivals.movie="{ item }">
          <v-chip
              v-for="(movie, index) in [...new Set(item.user_movie_graphic_festivals.movie)]"
              :key="index"
              color="primary"
          >
            {{ getMovieYear(movie) }}
          </v-chip>
        </template>
        <template v-slot:item.user_movie_graphic_festivals.graphic="{ item }">
          <v-chip
              v-for="(graphic, index) in [...new Set(item.user_movie_graphic_festivals.graphic)]"
              :key="index"
              color="primary"
          >
            {{ getGraphicYear(graphic) }}
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <v-btn
              color="primary"
              dark
              rounded
              @click="row_click(item)"
          >
            <v-icon
            >
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
  <v-row justify="center">
    <v-pagination
        v-model="page"
        :length="$store.state.Admin.admin.user_list.number_of_pages"
    ></v-pagination>
  </v-row>
</v-container>
</template>

<script>
import UserListFilterCard from "@/components/admin_v2/Cards/UserListFilterCard";
import {mapState} from "vuex";
import Statics from "@/components/common/Statics";
export default {
  name: "userList",
  components: {UserListFilterCard},
  data :()=>{
    return{
      headers :[
        {text:'نام کاربر' , value :'full_name'},
        {text:'تلفن همراه' , value :'phone'},
        {text:'شهر' , value :'city'},
        {text:'مقطع تحصیلی' , value :'grade'},
        {text:'کد ملی' , value :'national_code'},
        {text:'دوره فیلم' , value :'user_movie_graphic_festivals.movie'},
        {text:'دوره گرافیک' , value :'user_movie_graphic_festivals.graphic'},
        {text:'اطلاعات کاربر' , value :'id'},
      ],
      grade_numbers :Statics.grade_numbers,
      movie_years: Statics.movie_years,
      graphic_years : Statics.graphic_years
    }
  },
computed :{
    selected :{
      get(){
        return this.$store.state.Admin.admin.user_list.selected
      },
      set (value){
        this.$store.commit('set_user_list_selected', value)
      }
    },
  page:{
      get(){
        return this.$store.state.Admin.admin.user_list.page
      },
    set(value){
      this.$store.commit('set_admin_user_list' , value)
        this.$store.state.Admin.admin.user_list.items = []
      this.api_call()

    }
  },
  ...mapState({
    users : state => state.Admin.admin.user_list.items,
    count : state => state.Admin.admin.user_list.count,
    loading :state => state.Admin.admin.loading
  }),
},
  methods:{
    row_click(item) {
      this.$router.push({name: 'userData', params: {'id': item.id}})
    },
    api_call() {
        if (this.$store.state.Admin.admin.user_list.filter.filtered) {
          this.$store.dispatch('filter_users' )
        } else {
            this.$store.dispatch('get_users')
        }
    },
    getGradeName(gradeValue) {
      const grade = this.grade_numbers.find((g) => g.value === gradeValue);
      return grade ? grade.name : 'نامشخص';
    },
    getMovieYear(yearValue) {
      const year = this.movie_years.find((y) => y.value === yearValue);
      return year ? year.text : 'نامشخص';
    },
    getGraphicYear(yearValue) {
      const year = this.graphic_years.find((y) => y.value === yearValue);
      return year ? year.text : 'نامشخص';
    },
  },
  mounted() {
    this.api_call()
  }
}
</script>

<style scoped>

</style>


